export const driverInfo = {
    state: { //Contain data we want to use in our store, like data property of Vue Component
        driverUpdateForm: {}, //Use to store driver data in update form
    }, 
    getters: { //Get data from our state

    }, 
    mutations: { //Function to change value of state (commit mutation), we can't trigger asyc code inside mutation.
        DRIVER_UPDATEFORM(state, payload) {
            state.driverUpdateForm = payload
        },
    }, 
    actions: { //Function to commit mutations, we can have async code in actions
        driver_updateform({ commit }, value) {
            commit('DRIVER_UPDATEFORM', value)
        },
    },
};